import React from 'react';
import { Card, Skeleton } from 'antd';




import { table } from './struct';

const withTableController = (Table) => {
  // eslint-disable-next-line react/display-name
  return ({  dataConverter, state }) => {
    const { toTableData } = dataConverter || {};



    return (
      <Card {...table.wrapper}>

        {state  ? (
          <Table planing={state?.form_no === "1.2" ? toTableData(state?.planning) : state.planning} state={state} />
        ) : (
          <Skeleton loading={!state ? true : false} active />
        )}

      </Card>
    );
  };
};

export default withTableController;
